// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.option-fields[data-v-8d02dc24] {\n  margin: 0 -10px;\n}\n.option-fields__radio[data-v-8d02dc24] {\n  margin: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
